import api from './api';

const redactionService = {
  // Jobs
  createJob: (documentId) =>
    api.post('/redaction/jobs', { document_id: documentId }),

  getJob: (jobId) =>
    api.get(`/redaction/jobs/${jobId}`),

  listJobs: (documentId) =>
    api.get('/redaction/jobs', { params: { document_id: documentId } }),

  // Pages
  getPageImageUrl: (jobId, pageNum, dpi = 150) =>
    `${api.defaults.baseURL}/redaction/jobs/${jobId}/pages/${pageNum}?dpi=${dpi}`,

  getPageText: (jobId, pageNum) =>
    api.get(`/redaction/jobs/${jobId}/page-text/${pageNum}`),

  // Marks
  createMarks: (jobId, marks) =>
    api.post(`/redaction/jobs/${jobId}/marks`, { marks }),

  updateMark: (jobId, markId, data) =>
    api.put(`/redaction/jobs/${jobId}/marks/${markId}`, data),

  deleteMark: (jobId, markId) =>
    api.delete(`/redaction/jobs/${jobId}/marks/${markId}`),

  // Auto-detect
  autoDetect: (jobId, patterns) =>
    api.post(`/redaction/jobs/${jobId}/auto-detect`, { patterns }),

  // Apply
  applyRedactions: (jobId, markIds = null) =>
    api.post(`/redaction/jobs/${jobId}/apply`, { mark_ids: markIds }),

  // Download
  getDownloadUrl: (jobId) =>
    api.get(`/redaction/jobs/${jobId}/download-redacted`),

  // Reason codes
  getReasonCodes: () =>
    api.get('/redaction/reason-codes'),
};

export default redactionService;
